/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Sociaalemotioneeldomein_Inzetengedrag6Inputs */

const nl_enums_sociaalemotioneeldomein_inzetengedrag6 = /** @type {(inputs: Enums_Sociaalemotioneeldomein_Inzetengedrag6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzet en gedrag`)
};

/**

* @param {Enums_Sociaalemotioneeldomein_Inzetengedrag6Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_sociaalemotioneeldomein_inzetengedrag6 = /** @type {((inputs?: Enums_Sociaalemotioneeldomein_Inzetengedrag6Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Sociaalemotioneeldomein_Inzetengedrag6Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_sociaalemotioneeldomein_inzetengedrag6(inputs)
});
export { enums_sociaalemotioneeldomein_inzetengedrag6 as "enums.SociaalEmotioneelDomein.InzetEnGedrag" }